// extracted by mini-css-extract-plugin
export default {"wrapper":"StrategiesCard_wrapper__FsGxz","value":"StrategiesCard_value__QGj0V","title":"StrategiesCard_title__a3ssF"};